export default "__VITE_ASSET__2bf891eb__"